import React from 'react'
import StartLabel from './StartLabel'

type Props = {
    name: string
    label: string
    /** Only Accept a single Element
     */
    children: JSX.Element
}

/**
 *  Must be in the grid container to display properly
 * */
export const StartLabelField: React.VFC<Props> = ({ name, children, label, ...fieldProps }: Props) => {
    // const id = useOpaqueIdentifier() // Coming in React 18
    const id = name
    return (
        <>
            {/* @ts-expect-error Missing htmlFor prop */}
            <StartLabel as="label" htmlFor={id}>
                {label}
            </StartLabel>
            {React.cloneElement(children, {
                id,
                ...fieldProps,
            })}
        </>
    )
}

export default StartLabelField
export type { Props as StartLabelFieldProps }
